/* This directive is for automatically aligning the dropdown submenu
 * It assumes right align as the default alignment. If the submenu dropdown
 * is cut by the right edge of the window, it will align the menu to the left
 * USE: Add it to the containing element of the submenu
 */
import 'angular';

angular.module('GorillaBoy.directives')
.directive('dropdownSubmenuAutoAlign', ['$log', ($log) => {
    return {
        restrict: 'A',
        scope: true,
        link: function($scope, $element, $attrs) {
            init();

            function init() {
                // Notice, the container element itself is the toggle for the submenu
                $scope.dropdownToggle = $element;
                $scope.dropdownMenu = $element.children('.dropdown-menu');
                if ($scope.dropdownMenu.length === 1) {
                    $element.on('mouseenter', onMouseEnterHandler);
                } else {
                    $log.error('dropdownSubmenuAutoAlign failed in initialization.');
                    $log.error('dropdownSubmenuAutoAlign failed: dropdownToggle.length: '
                        + $scope.dropdownToggle.length
                        + 'dropdownMenu.length: '
                        + $scope.dropdownMenu.length);
                }
            }

            function onMouseEnterHandler(evt) {
                if (isSubmenuOnLeft() && submenuCanBeOnRight()) {
                    setSubMenuToRight()
                }

                if (isSubmenuOutOfWindow()) {
                    setSubMenuToLeft()
                }
            }

            function isSubmenuOnLeft() {
                return $element.hasClass('left-align');
            }

            function isSubmenuOutOfWindow() {
                var dropdownMenuBCR = $scope.dropdownMenu[0].getBoundingClientRect();
                var windowWidth = $(window).width();
                return dropdownMenuBCR.right > windowWidth;
            }

            function submenuCanBeOnRight() {
                var dropdownMenuBCR = $scope.dropdownMenu[0].getBoundingClientRect();
                var windowWidth = $(window).width();
                var parentMenuWidth = $element[0].getBoundingClientRect().width;
                var calculatedRight = dropdownMenuBCR.right + dropdownMenuBCR.width + parentMenuWidth;
                return calculatedRight < windowWidth;
            }
            
            function setSubMenuToRight() {
                $element.removeClass('left-align');
            }

            function setSubMenuToLeft() {
                $element.addClass('left-align');
            }
        }
    };
}])
